import {
  HasuraDataTableColumnDef,
  TablePageLayout,
  DataTableEx,
  DataTableExRef,
} from '@kirz/mui-admin';
import { Button } from '@mui/material';
import { Calendar } from 'mdi-material-ui';
import React, { useContext, useMemo, useRef } from 'react';

import { GridNameColumn } from 'components/GridNameColumn';
import { AppStateContext } from 'contexts/AppStateContext';
import { UserContext } from 'contexts/UserContext';

export function Waves() {
  const { selectedStationId } = useContext(AppStateContext);
  const { user } = useContext(UserContext);
  const tableRef = useRef<DataTableExRef>(null);

  const columns = useMemo<HasuraDataTableColumnDef[]>(
    () => [
      {
        field: 'name',
        headerName: 'Name',
        flex: 1,
        renderCell({ row }) {
          return <GridNameColumn url={`/waves/${row.id}`} text={row.name} />;
        },
      },
      {
        field: 'campaign { *name* }',
        headerName: 'Campaign',
        type: 'relationship',
        flex: 1,
      },
      { field: 'createdAt', headerName: 'Created at', type: 'date' },
      {
        field: 'calendar',
        headerName: ' ',
        selector: false,
        disableColumnMenu: true,
        sortable: false,
        width: 100,
        renderCell({ row }) {
          return (
            <Button
              size="small"
              startIcon={<Calendar />}
              href={`/waves/${row.id}/overview`}
            >
              Calendar
            </Button>
          );
        },
      },
    ],
    [],
  );

  return (
    <TablePageLayout title="Waves">
      <DataTableEx
        id="waves-table"
        ref={tableRef}
        source="wave"
        columns={columns}
        automaticallyOpenEditPage={false}
        editPageUrl="/waves"
        sortBy={{ field: 'createdAt', sort: 'desc' }}
        persistStateMode="query"
        searchFilter={{
          inputProps: {
            placeholder: 'Search by name or campaign',
          },
          filter: (search) => ({
            _or: search.flatMap((str) => [
              {
                _or: [
                  { name: { _ilike: `%${str}%` } },
                  { campaign: { name: { _ilike: `%${str}%` } } },
                ],
              },
            ]),
          }),
        }}
        selectProps={{
          filter: {
            companyId: { _eq: user.companyId },
            stationId: { _eq: selectedStationId },
          },
        }}
      />
    </TablePageLayout>
  );
}
